import React, { forwardRef } from 'react';
import {
  NavLink as RouterLink,
  useParams,
  useLocation
} from 'react-router';
import { makeStyles } from '@mui/styles';
import {
  Typography, List, ListItem, Drawer, ListItemText
} from '@mui/material';
import { PlaceHolderText } from 'components/PlaceholderCard/PlaceholderCard';
import Progress from 'components/Progress/Progress';
import radioBackboneList from './radioBackboneList';

const drawerWidth = 320;

const useStyles = makeStyles((theme) => ({
  drawer: {
    width: drawerWidth,
    flexShrink: 0,

  },
  drawerPaper: {
    width: drawerWidth,
    zIndex: 1000
  },
  drawerContainer: {
    paddingTop: 100,
    overflow: 'auto',
    height: '100%',
  },
  listItemRoot: {
    padding: `${theme.spacing(2)}px ${theme.spacing(2)}px`,
  },
  selected: {
    '&$selected': {
      borderLeft: `4px solid ${theme.palette.primary.main}`,
    }
  }
}));

const CustomRouterRouterLink = forwardRef((props, ref) => (
  <div
    ref={ref}
    style={{ width: '100%' }}
  >
    <RouterLink {...props} />
  </div>
));

const RadioLeftView = ({ config }) => {
  const { id } = useParams();
  const location = useLocation();
  const classes = useStyles();

  const data = radioBackboneList;

  const height = '100vh';

  const renderData = () => {
    if (data.length === 0) {
      return <PlaceHolderText content="No Data" height={height} />;
    }

    return (
      <List className="radio-backbones">
        {data.map((item) => {
          const selected = config.isSelectedRow(item);
          return (
            <ListItem
              key={config.templates.key(item)}
              button
              component={CustomRouterRouterLink}
              to={{
                pathname: config.templates.pageLink(item),
                search: location.search
              }}
              selected={selected}
              classes={{
                root: classes.listItemRoot,
                selected: classes.selected
              }}
              divider
            >
              <ListItemText
                disableTypography
                primary={<Typography variant="h6">{config.templates.primaryText(item)}</Typography>}
                secondary={config.templates.secondaryText(item)}
              />
            </ListItem>
          );
        })}
      </List>
    );
  };

  return (
    <Drawer
      variant="permanent"
      classes={{
        paper: classes.drawerPaper,
      }}
    >
      <div className={classes.drawerContainer}>
        {!id ? <Progress /> : renderData()}
      </div>
    </Drawer>
  );
};

export default RadioLeftView;
